import { render, staticRenderFns } from "./IncomingMovements.vue?vue&type=template&id=4d1981e6"
import script from "./IncomingMovements.vue?vue&type=script&lang=js"
export * from "./IncomingMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports